<template>
  <div v-if="isVisible" class="notice-overlay" @click="closeNotice">
    <div class="notice-popup" @click.stop>
      <div class="notice-header">
        <h3 class="notice-title">店家公告</h3>
      </div>
      <div class="notice-content" v-html="sanitizedNotice"></div>
      <div class="notice-footer">
        <button @click="closeNotice" class="confirm-btn">
          確認
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { sanitizeHtml } from '@/utils/htmlSanitizer.utils'
import { mapGetters } from 'vuex'
import { shouldShowNotice } from '@/utils/storeNotice.utils'

export default {
  name: 'StoreNoticePopup',
  
  props: {
    // 手動控制模式（預設為 false，使用自動模式）
    manualMode: {
      type: Boolean,
      default: false
    },
    // 手動控制顯示狀態（僅在 manualMode 為 true 時有效）
    show: {
      type: Boolean,
      default: false
    }
  },
  
  data() {
    return {
      isClosed: false  // 用戶是否已關閉公告
    }
  },
  
  computed: {
    ...mapGetters('basic', ['noticeContent', 'noticeEnabled']),
    ...mapGetters('userData', ['isLogin', 'storeMemberUuid', 'storeCode']),
    
    // 統一的顯示邏輯
    isVisible() {
      // 手動模式：由父組件的 show prop 控制
      if (this.manualMode) {
        return this.show
      }
      
      // 自動模式：原有邏輯
      if (this.isClosed) return false
      if (!this.isLogin || !this.storeMemberUuid || !this.storeCode) return false
      if (!this.noticeEnabled || !this.noticeContent) return false
      
      return shouldShowNotice(this.storeMemberUuid, this.storeCode, this.noticeEnabled, this.noticeContent)
    },
    
    // 淨化後的公告內容
    sanitizedNotice() {
      if (!this.isVisible) return ''
      return sanitizeHtml(this.noticeContent)
    }
  },
  
  methods: {
    /**
     * 關閉公告跳窗
     */
    closeNotice() {
      if (this.manualMode) {
        // 手動模式：觸發事件讓父組件控制
        this.$emit('close')
      } else {
        // 自動模式：內部控制
        this.isClosed = true
        // 標記公告已顯示（用於下次載入）
        this.$store.dispatch('basic/markNoticeAsShown')
      }
    }
  }
}
</script>

<style scoped>
/* 公告跳窗樣式 */
.notice-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.notice-popup {
  background: white;
  border-radius: 12px;
  max-width: 90%;
  max-height: 80%;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
}

.notice-header {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.notice-title {
  margin: 0;
  font-size: 24px;
  font-weight: bold;
  color: #ff6b35;
  text-align: center;
  line-height: 1.2;
}

.notice-content {
  padding: 20px;
  max-height: 400px;
  overflow-y: auto;
  line-height: 1.6;
  flex: 1;
}

.notice-content :deep(p) {
  margin: 0 0 12px 0;
}

.notice-content :deep(p:last-child) {
  margin-bottom: 0;
}

.notice-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  border-top: 1px solid #eee;
  background-color: #ffffff;
}

.confirm-btn {
  background-color: #FBCB02;
  border: none;
  border-radius: 8px;
  padding: 12px 32px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  min-width: 100px;
}

</style>